import React, {useState, useEffect} from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import {useSelector} from 'react-redux';
import {useInit} from '../hooks/useInit';
import i18next from 'i18next';
// importar tus componentes necesarios
import SplashScreen from '../screens/splash';
import LoginScreen from '../screens/signin/login';
import HomeScreen from '../screens/menu';
import HomeScreen2 from '../screens/menu/index2';
import MenuListScreen from '../screens/menu/list';
import MenuDetailScreen from '../screens/menu/detail';

import DrinkScreen from '../screens/menu/drink';
import SpecialScreen from '../screens/menu/special';
// import Footer from '@app/components/footer';
import { KeepAlive} from 'react-activation';

const RootNavigator = () => {
   const { progress } = useInit();
  i18next.changeLanguage('es')
  const {
    isFirstLoad, 
    isSingin,
  } = useSelector((state) => state.initLoad);

  return (
    <Router>
      <Routes>
        {isFirstLoad ? (
           <Route path="/*" element={<SplashScreen progress={progress} />} />
        ) : (
          <>
            {isSingin ? (
              <>
                  <Route path="/" element={ <KeepAlive><HomeScreen /></KeepAlive>} />
                  <Route path="/test" element={<HomeScreen2 />} />
                  <Route path="MenuList" element={<MenuListScreen />} />
                  <Route path="MenuDetail" element={<MenuDetailScreen />} />
                 
                  <Route path="drinks" element={<DrinkScreen />} />
                  <Route path="special" element={<SpecialScreen />} />
              </>
            ) : (
              <Route path="/*" element={<LoginScreen />} />
            )}
          </>
        )}
      </Routes>
      {/* <Footer /> */}
    </Router>
  );
};

export default RootNavigator;
